/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IDependent } from 'src/interfaces';
import { useTranslation } from 'react-i18next';
import PersonalInfoService from 'src/services/personal-info.service';

export const useAddDependent = (): UseMutationResult<
  any,
  Error,
  { dependent: IDependent; personnelNumber: string },
  void
> => {
  const { t } = useTranslation();

  return useMutation(
    (data: { dependent: IDependent; personnelNumber: string }) =>
      PersonalInfoService.postDependent(data.dependent, data.personnelNumber),
    {
      onSuccess: () => {
        AlertAdapter(t('messages.dependentAddSuccess'), 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
};

export const useUpdateDependent = (): UseMutationResult<
  any,
  Error,
  { dependent: IDependent; personnelNumber: string },
  void
> => {
  const { t } = useTranslation();
  return useMutation(
    (data: { dependent: IDependent; personnelNumber: string }) =>
      PersonalInfoService.updateDependent(data.dependent, data.personnelNumber),
    {
      onSuccess: () => {
        AlertAdapter(t('messages.dependentUpdateSuccess'), 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
};

export const useDeleteDependent = (): UseMutationResult<void, Error, { dependent: IDependent }> => {
  return useMutation(({ dependent }: { dependent: IDependent }) => PersonalInfoService.deleteDependent(dependent), {
    onSuccess: () => {
      AlertAdapter('Dependent successfully deleted.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter('Error deleting dependent: ' + e.message, 'error');
    },
  });
};
